import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HalfHero from "../Images/main.jpg";
import Navbar from "../Components/Navbar";
import SearchBar from "../Components/SearchBar";
import BigLocationCard from "../Components/BigLocationCard";
import S1 from "../Images/States/andhraPradesh.png";
import S2 from "../Images/States/arunachalPradesh.png";
import S3 from "../Images/States/assam.png";
import S4 from "../Images/States/bihar.png";
import S5 from "../Images/States/chattisgarh.png";
import S6 from "../Images/States/delhi.jpg";
import S7 from "../Images/States/goa.png";
import S8 from "../Images/States/gujarat.png";
import S9 from "../Images/States/haryana.png";
import S10 from "../Images/States/himachalPradesh.png";
import S11 from "../Images/States/jharkhand.png";
import S12 from "../Images/States/karnataka.png";
import S13 from "../Images/States/kerala.png";
import S14 from "../Images/States/madhyaPradesh.png";
import S15 from "../Images/States/maharastra.png";
import S16 from "../Images/States/manipur.png";
import S17 from "../Images/States/meghalya.png";
import S18 from "../Images/States/mizoram.png";
import S19 from "../Images/States/nagaland.png";
import S20 from "../Images/States/odisha.png";
import S21 from "../Images/States/punjab.png";
import S22 from "../Images/States/rajasthan.png";
import S23 from "../Images/States/sikkim.png";
import S24 from "../Images/States/tamilNadu.png";
import S25 from "../Images/States/telangana.png";
import S26 from "../Images/States/tripura.png";
import S27 from "../Images/States/uttarPradesh.png";
import S28 from "../Images/States/uttrakhand.png";
import S29 from "../Images/States/westBengal.png";

// Static states data (copied from Location.jsx)
const STATES = [
  { name: "Andhra Pradesh", img: S1, latitude: 15.9129, longitude: 79.74 },
  { name: "Arunachal Pradesh", img: S2, latitude: 28.218, longitude: 94.7278 },
  { name: "Assam", img: S3, latitude: 26.2006, longitude: 92.9376 },
  { name: "Bihar", img: S4, latitude: 25.0961, longitude: 85.3131 },
  { name: "Chhattisgarh", img: S5, latitude: 21.2787, longitude: 81.8661 },
  { name: "Delhi", img: S6, latitude: 28.7041, longitude: 77.1025 },
  { name: "Goa", img: S7, latitude: 15.2993, longitude: 74.124 },
  { name: "Gujarat", img: S8, latitude: 22.2587, longitude: 71.1924 },
  { name: "Haryana", img: S9, latitude: 29.0588, longitude: 76.0856 },
  { name: "Himachal Pradesh", img: S10, latitude: 31.1048, longitude: 77.1734 },
  { name: "Jharkhand", img: S11, latitude: 23.6102, longitude: 85.2799 },
  { name: "Karnataka", img: S12, latitude: 15.3173, longitude: 75.7139 },
  { name: "Kerala", img: S13, latitude: 10.8505, longitude: 76.2711 },
  { name: "Madhya Pradesh", img: S14, latitude: 22.9734, longitude: 78.6569 },
  { name: "Maharashtra", img: S15, latitude: 19.7515, longitude: 75.7139 },
  { name: "Manipur", img: S16, latitude: 24.6637, longitude: 93.9063 },
  { name: "Meghalaya", img: S17, latitude: 25.467, longitude: 91.3662 },
  { name: "Mizoram", img: S18, latitude: 23.1645, longitude: 92.9376 },
  { name: "Nagaland", img: S19, latitude: 26.1584, longitude: 94.5624 },
  { name: "Odisha", img: S20, latitude: 20.9517, longitude: 85.0985 },
  { name: "Punjab", img: S21, latitude: 31.1471, longitude: 75.3412 },
  { name: "Rajasthan", img: S22, latitude: 27.0238, longitude: 74.2179 },
  { name: "Sikkim", img: S23, latitude: 27.533, longitude: 88.5122 },
  { name: "Tamil Nadu", img: S24, latitude: 11.1271, longitude: 78.6569 },
  { name: "Telangana", img: S25, latitude: 18.1124, longitude: 79.0193 },
  { name: "Tripura", img: S26, latitude: 23.9408, longitude: 91.9882 },
  { name: "Uttar Pradesh", img: S27, latitude: 26.8467, longitude: 80.9462 },
  { name: "Uttarakhand", img: S28, latitude: 30.0668, longitude: 79.0193 },
  { name: "West Bengal", img: S29, latitude: 22.9868, longitude: 87.855 },
];

const Location = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(STATES);

  // Haversine distance function
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Handle sorting when a card is clicked
  const handleSelect = (selected) => {
    const sorted = [...STATES].sort((a, b) => {
      const distA = calculateDistance(
        selected.latitude,
        selected.longitude,
        a.latitude,
        a.longitude
      );
      const distB = calculateDistance(
        selected.latitude,
        selected.longitude,
        b.latitude,
        b.longitude
      );
      return distA - distB;
    });
    setItems(sorted);
  };

  const handleCardSelect = (state) => {
    // Pass state name as query param
    navigate(`/services?lat=${state.latitude}&lng=${state.longitude}`);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    });
  };

  return (
    <>
      <section className="relative w-full h-1/2 overflow-hidden">
        {/* Background Image (with blur) */}
        <img
          src={HalfHero}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />

        {/* Navbar */}
        <Navbar />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70 z-[-5]" />

        {/* Content on top of image */}
        <div className="relative z-10 h-full text-white flex flex-col justify-center items-center">
          <div className="h-3/4 w-3/4 text-white flex flex-col justify-center items-center gap-5">
            <h1 className="text-xl font-bold text-center mulish-light uppercase">
              Welcome to <br />
              <span className="text-xl font-bold md:text-5xl md:mulish-bold tracking-wider bg-gradient-to-r from-orange-500 via-white to-green-500 bg-clip-text text-transparent ">
                ONLINE INDIAN MARKET
              </span>
            </h1>
            <p className="mt-0 md:mt-2 text-sm mulish-light tracking-wider text-center uppercase">
              Get the Nearest and Best Services in the Market.
            </p>
            <SearchBar />
            <div className="flex flex-row justify-around w-3/4"></div>
          </div>
        </div>
      </section>

      <section className="flex justify-center items-center py-12 px-4 bg-gray-100">
        <BigLocationCard data={items} onSelect={handleCardSelect} />
      </section>
    </>
  );
};

export default Location;
